import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: 'e30c37f003f33ac306852ab920e5f012.png',
	fr: '10c33bb320254159247468e383f01bfa.png',
};

export const ShakerTry: FunctionComponent = () => {
	const {t} = useTranslation();
	const src = useLocalImage(IMAGE_CONFIG);
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'shakerlandingpage_title_cocreatedsharedplaylists_standalone-web',
							{ns: 'shaker'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'shakerlandingpage_text_cocreatedsharedplaylists_standalone-web',
							{ns: 'shaker'},
						)}
					</LandingParagraph>
					<LandingButtonLink
						tracking={{eventaction: 'discover'}}
						target="_blank"
						href="https://link.deezer.com/?dest=https%3A%2F%2Fwww.deezer.com%2Fmusictogether%2Fgroups&amv=8.0.34&imv=10.34.0&gwf=https%3A%2F%2Fshaker.deezer.com%2Fgroups"
					>
						{t('musictogether_action_tryshaker_standalone-web', {
							ns: 'common',
						})}
					</LandingButtonLink>
				</>
			}
			image={
				<Image
					objectFit="contain"
					aspectRatio="2880/1012"
					src={src}
					alt={'Shaker'}
				/>
			}
		/>
	);
};
